import React from 'react'
import { Button, EditableTitle } from '@components/atoms'
import styles from './DocumentiCard.module.sass'
import useTrans from '@hooks/useTrans'
import { ArchivioDocumentiListingNode, PaginaNode } from '@gql/graphql'
import { ArrowDownUnderline, Document } from '@components/icons'
import { formatDate } from '@utils/index'
import { handleDowloadFileTracking } from '@utils/tracking'
import { useRouter } from 'next/router'

interface Props {
  documento: ArchivioDocumentiListingNode
  editMode?: boolean
  className?: string
  pagina?: PaginaNode
}

const DocumentiCard = (props: Props) => {
  const { documento = undefined, editMode = false, className = '', pagina } = props

  const t = useTrans()
  const router = useRouter()

  const handleClick = () => {
    handleDowloadFileTracking(documento.nome, pagina?.slug)
  }

  return documento ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <div className={styles.main}>
        <div className={styles.top}>
          <span className={styles.icon}>
            <Document />
          </span>

          {!!documento.dataPubblicazione && (
            <span className={styles.date}>{formatDate(documento.dataPubblicazione)}</span>
          )}
        </div>
        {!!documento.nome && (
          <EditableTitle
            title={documento.nome}
            variant="h4"
            className={styles.title}
            editMode={editMode}
          />
        )}
        {!!documento.url && (
          <div className={styles.ctaBox}>
            <Button
              label={t('Apri documento')}
              href={documento.url}
              variant="ghost"
              iconRight={<ArrowDownUnderline />}
              onClick={handleClick}
              newPage
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default DocumentiCard
